(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name missingSignIn.controller:MissingSignInCtrl
	 *
	 * @description
	 *
	 */
	angular
	.module('missingSignIn')
	.directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
	.controller('MissingSignInCtrl',MissingSignInCtrl);

	function MissingSignInCtrl(EventManagerService, CommonMasterData,MissingSignInService,
			MessageService, PopupManager, applicationConstants,crewScheduleService) {
		var vm = this;
		vm.ctrlName = 'MissingSignInCtrl';

		vm.model = {
			searchOnGoing : false,
			searchPanelToggle : true,
			initialSearchDone : false,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				crewType : null,
				crewName :null,
				crewId :null,
				base:null,
				status:null
			},
			masterList : {
				crewTypes : [],
				baseList :[],
				statusList :[],
				crewNameList:[]
			},
			missingSignInList : [],
			missingSignOutList : [],

			selectedCrewBatch : null,
			isElasticLoadingVisible : false
		};


		EventManagerService.registerEventListener(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_IN_DATA, refreshMissingSignInData);
		EventManagerService.registerEventListener(EventManagerService.EVENT.MISSIN_SIGN_IN.RELOAD_SIGN_OUT_DATA, refreshMissingSignOutData);


		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		vm.searchByOptions = function(searchParams) {
			setDefault();
			vm.missingSignInData();
			vm.missingSignOutData();
		}

		vm.missingSignOutData = function() {
			vm.model.missingSignOutList = [];
			vm.model.initialSearchDone = true;
			missingSignOutData();
		};

		vm.missingSignInData = function() {
			vm.model.missingSignInList = [];
			vm.model.initialSearchDone = true;
			missingSignInData();
		};

		vm.clickOnSignIn = function(selectedRowData){
			var param = {};
			param.crewScheduleBlockId = selectedRowData.crewScheduleBlockId;
			param.checkInDate = selectedRowData.checkInDate;
			param.checkInTime = selectedRowData.checkInTime;
			param.isLegal = selectedRowData.isLegal;
			PopupManager.openModal('DO_SIGN_IN', param, onSendAlertClose);
		}

		vm.clickOnSignOut = function(selectedRowData,flag){
			var param = {};
			param.crewScheduleBlockId = selectedRowData.crewScheduleBlockId;
			param.checkOutDate = selectedRowData.checkOutDate;
			param.checkOutTime = selectedRowData.checkOutTime;

			if(flag==='SIGN_OUT'){
				PopupManager.openModal('DO_SIGN_OUT', param, onSendAlertClose);
			}else if(flag ==='ALLOW_REPORT'){
				PopupManager.openModal('ACTIVATE_FLIGHT_REPORT', param, onSendAlertClose);
			}else if(flag ==='EXTEND_DEADLINE'){
				PopupManager.openModal('EXTEND_DEADLINE_TIME', param, onSendAlertClose);
			}else{
				console.log('row click status not found');
			}

		}

		vm.changeSearchField = function(searchParams, flag){
			if (flag === 'crewType') {
				vm.model.searchCriteria.crewName = null;
				vm.model.searchCriteria.crewId = null;
				loadCrewList(vm.model.searchCriteria.crewType);
			} else if(flag === 'crewName') {
				vm.model.searchCriteria.crewId = vm.model.searchCriteria.crewName.crewId;
			} else if (flag === 'fromDate') {
				var tempFromDate = moment(vm.model.searchCriteria.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
	        	if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE") {
	        		vm.model.searchCriteria.toDate = tempFromDate;
	        	}
			} else {
				vm.model.searchCriteria.crewName = null;
				vm.model.searchCriteria.crewType = null;
			}
		}

		function refreshMissingSignOutData(){
			vm.missingSignOutData();
		}

		function refreshMissingSignInData(){
			vm.missingSignInData();
		}

		function onSendAlertClose(pass) {}

		function setDefaultDates(){
			var date = new Date();
			date.setDate(date.getDate() - 1);

			vm.model.searchCriteria.fromDate = moment(date).format('DD/MM/YYYY');
			vm.model.searchCriteria.toDate =  moment(new Date()).format('DD/MM/YYYY');
		}

		function missingSignOutData() {
			showLoader(true);
			MissingSignInService.setSearchCriteria(vm.model.searchCriteria);
			MissingSignInService.searchMissingSignOutData(
				function(missingSignOutData) {
					updateMissingSignOut(missingSignOutData);
					vm.model.searchPanelToggle = false;
					showLoader(false);
					vm.model.searchOnGoing = false;
			}, function(error) {
					MessageService.error(error);
					showLoader(false);
			});

		}

		function updateMissingSignOut(missingSignOutData) {
			angular.forEach(missingSignOutData, function(missingSignOut) {
				vm.model.missingSignOutList.push(missingSignOut);
			});
			vm.model.isElasticLoadingVisible = false;
		}

		function missingSignInData() {
			showLoader(true);
			MissingSignInService.setSearchCriteria(vm.model.searchCriteria);
			MissingSignInService.searchMissingSignInData(function(missingSignInData) {
				updateMissingSignIn(missingSignInData);
				vm.model.searchPanelToggle = false;
				showLoader(false);
				vm.model.searchOnGoing = false;
			}, function(error) {
				MessageService.error(error);
				showLoader(false);
			});

		}

		function updateMissingSignIn(missingSignInData) {
			angular.forEach(missingSignInData, function(missingSignIn) {
				vm.model.missingSignInList.push(missingSignIn);
			});
			vm.model.isElasticLoadingVisible = false;
		}

		function showLoader(flag) {
			EventManagerService.notifyEventListeners(
					EventManagerService.EVENT.SHOW_HIDE_LOADING, {
						flag : flag,
						animationName : 'crewing-loader'
					});
		}


		function setDefault() {
			vm.model.searchCriteria.pageSize = 100;
			vm.model.searchCriteria.startPosition = 1;
		}


		function loadCrewList(crewType) {

			var param = {};
			param.crewType = '';
			param.active = true;
			if (!!crewType) {
				param.crewType = crewType.crewTypeCode;
				CommonMasterData.loadCrewList(param, function(response) {
						vm.model.masterList.crewNameList = crewScheduleService
								.adaptCrewList(response);

				}, function() {
					console.log('User name list retrieval error');
				});
			} else {
				vm.model.masterList.crewNameList = null;
			}
		};

		CommonMasterData.getCrewTypeList(function(crewTypeList){
		   	vm.model.masterList.crewTypes = crewTypeList;
		},function () {
			console.log('Crew Types List retrieval error');
		});

		CommonMasterData.getCrewBaseList(function(baseList) {
			vm.model.masterList.baseList = baseList;
		}, function() {
			console.log('Crew Base List retrieval error');
		});

		CommonMasterData.getMissingReportStatusList(function(status){
			vm.model.masterList.statusList = status;
		}, function() {
			console.log('Crew Base List retrieval error');
		});

		setDefaultDates();
		vm.searchByOptions();

	}
}());
